import { InvitationStatusEnum } from '@sr-sdks/api-sdk-axios';
import { StatusBadge } from './Badges/StatusBadge';

interface IInvitationStatus {
  expires: string;
  invitationStatus: InvitationStatusEnum;
}

export const InvitationStatus = ({
  expires,
  invitationStatus,
}: IInvitationStatus) => {
  // The stored status lags behind the clock, so an invitation past its expiry
  // reads as Expired. A failed invitation keeps its own status either way.
  const hasLapsed =
    invitationStatus !== InvitationStatusEnum.Failed &&
    Boolean(expires) &&
    new Date(expires) < new Date();

  return (
    <StatusBadge
      group="Invitation"
      type={hasLapsed ? InvitationStatusEnum.Expired : invitationStatus}
    />
  );
};
